import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs';
import { BlobResponse } from '../../Models/OtherClasses';
import { AuthService } from '../../RoutingAuth/auth.service';
import { BaseBusyableComponent } from '../../Services/BaseBusyableComponent';
import { ConfigService } from '../../Services/ConfigService';
import { PropertyItemDocumentService } from '../../Services/Custom/ServicePropertyItemDocument';
import { pdfDefaultOptions } from 'ngx-extended-pdf-viewer';

@Component({
	selector: 'viewer',
	templateUrl: 'Viewer.html',
	
	styles: ['.homeMinHeight { line-height: 250px; }']
})
export class ViewerComponent extends BaseBusyableComponent implements OnInit {

	constructor(
		protected configData: ConfigService,
		private authService: AuthService,
		protected myPropertyItemDocumentService: PropertyItemDocumentService,
		private route: ActivatedRoute) {
		super();
		pdfDefaultOptions.assetsFolder = 'dist/assets';
	}

	blob: Blob = null;
	blobResponse: BlobResponse = null;

	ngOnInit() {
		if (this.configData.user) {
			this.route.params.subscribe(params => {
				var id = params['id'] || this.configData.DefaultEmptyGuid;
				this.loadItem(id);
			});
		} else {
			this.authService.login();
		}
	}
	loadItem(id: System.Guid) {
		this.myPropertyItemDocumentService.downloadDoc(id)
			.pipe(takeUntil(this.obsToCloseSubject))
			.subscribe(obj => {
				this.blob = obj.blob;
				this.blobResponse = obj;
			},
			(error: any) => {
				this.configData.goHome();
			}
			);
	}
}
